<template>
  <div class="container_self">
    <h3>文章模板</h3>

    <el-form
      label-width="120px"
      :model="templateForm"
      size="mini"
      class="articleFrom"
      width="80%"
    >
      <el-form-item label="域名">
        <el-select v-model="templateForm.domain" @change="domainChange">
          <el-option
            v-for="(item, index) in domainlist"
            :value="item.dm"
            :label="item.dm"
            :key="index"
          ></el-option>
        </el-select>
        <el-button
          size="mini"
          type="warning"
          style="margin-left: 15px"
          @click="checkTemplate"
          >查询</el-button
        >
      </el-form-item>
      <el-form-item label="类型">
        <el-select v-model="templateForm.item" @change="typeChange">
          <el-option
            v-for="(item, index) in items"
            :value="item.value"
            :label="item.label"
            :key="index"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="配置项">
        <el-input
          @keydown.enter.prevent
          type="textarea"
          :autosize="{ minRows: 20, maxRows: 400 }"
          placeholder="请输入内容"
          v-model="templateForm.value"
        >
        </el-input>
      </el-form-item>
      <el-form-item label="描述">
        <el-input placeholder="请输入描述" v-model="templateForm.description"></el-input>
      </el-form-item>

      <el-form-item style="width: 100%"
        ><el-button type="primary" style="float: right" @click="submit"
          >提交</el-button
        ></el-form-item
      >
    </el-form>
  </div>
</template>

<script>
import { axiosGet, axiosPost } from "@/assets/ajaxFn";

export default {
  data() {
    return {
      templateForm: {
        value: "",
        description: "",
        item: "index_template",
        domain: "",
      },
      domainlist: [],
      items: [
        {
          value: "index_template",
          label: "资讯模板首页",
        },
        {
          value: "list_template",
          label: "资讯模板列表页",
        },
        {
          value: "info_template",
          label: "资讯模板详情页",
        },
        {
          value: "privacy_policy_template",
          label: "隐私协议模板",
        },
        {
          value: "user_agreement_template",
          label: "用户隐私模板",
        },
        {
          value: "about_us_template",
          label: "关于我们",
        },
        {
          value: "contact_us_template",
          label: "联系我们",
        },
        {
          value: "authors_template",
          label: "作者",
        },
        {
          value: "changelog_template",
          label: "更新日志",
        },
      ],
    };
  },
  methods: {
    domainChange() {
      this.templateForm = {
        value: "",
        description: "",
        item: "index_template",
        domain: this.templateForm.domain,
      };
    },
    typeChange() {
      if (!this.templateForm.domain) {
        return false;
      }
      this.checkTemplate();
    },
    submit() {
      if (this.templateForm.value) {
        axiosPost("/api/cms/config/update", this.templateForm, "JSON").then((res) => {
          if (res.code == 0) {
            this.$message({ message: "更新成功", type: "success" });
          }
        });
      } else {
        this.$message({ message: "请填写内容", type: "error" });
      }
    },
    checkTemplate() {
      axiosGet("/api/cms/config/item", {
        domain: this.templateForm.domain,
        item: this.templateForm.item,
      }).then((res) => {
        if (res.code == 0) {
          if (res.data.id) {
            this.templateForm = res.data;
          }
        }
      });
    },
  },
  mounted() {
    axiosGet("/api/cms/article/domains").then((res) => {
      if (res.code == 0) {
        this.domainlist = res.data.length ? res.data : [];
        console.log(this.domainlist);
      }
    });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/view/ArticleManager/updateTemplate.vue